export enum PurchaseType {
    recurring_fixed = 'recurring_fixed',
    recurring_continuous = 'recurring_continuous',
    full_charge = 'full_charge',
}

// Rótulo de cada tipo de cobrança. Fonte única: as telas montam as opções a partir do que a api
// informa em gateway.gatewayPurchaseTypes e buscam o texto aqui.
// Nem todo gateway aceita todos — o Mercado Pago, por exemplo, não cobra com o cliente ausente,
// então só faz cobrança convencional.
export enum PurchaseTypeFriendly {
    full_charge = 'À vista ou parcelado no cartão',
    recurring_fixed = 'Carnê (valor total dividido em vencimentos)',
    recurring_continuous = 'Assinatura (cobra até cancelar)',
}

/**
 * A fronteira entre assinatura e cobrança, num lugar só.
 *
 * Assinatura é o que se paga POR PERÍODO, sem total e sem fim previsto — só a recorrente contínua.
 *
 * A recorrente fixa parece assinatura pelo nome, mas não é: ela divide um valor TOTAL em N
 * vencimentos, gera todas as parcelas de uma vez e não tem cancelamento nem pro-rata. É um carnê,
 * ou seja, uma venda fracionada — do mesmo lado da cobrança à vista. Quem para de pagar um carnê
 * ainda deve o saldo; quem cancela uma assinatura apenas deixa de receber.
 */
export function isSubscriptionType(type: PurchaseType | string): boolean {
    return type === PurchaseType.recurring_continuous
}

export const SUBSCRIPTION_TYPES = [PurchaseType.recurring_continuous]
export const CHARGE_TYPES = [PurchaseType.full_charge, PurchaseType.recurring_fixed]

export enum PurchaseStatus {
    denied = 5,
    pending = 10,
    canceled = 20,
    overdue = 80,
    active = 100,
}

// o que acontece com a cobrança já agendada quando um cancelamento é agendado.
// 'none' não é aceito no envio: é o resultado devolvido quando não havia cobrança a tratar.
export enum ScheduledCancelNextInstallment {
    cancel = 'cancel',
    full = 'full',
    prorated = 'prorated',
    none = 'none',
}

export enum ScheduledCancelNextInstallmentFriendly {
    cancel = 'não cobrar',
    full = 'cobrar valor cheio',
    prorated = 'cobrar proporcional aos dias usados',
    none = 'nenhuma cobrança a tratar',
}

export enum PurchaseStatusFriendly {
    denied = 'negado',
    pending = 'pendente',
    canceled = 'cancelado',
    overdue = 'em atraso',
    active = 'ativo',
}
